"use client";
import React from "react";

import { getInstallerPanelUrl } from "@/app/constants/general";

interface InstallerRegisterButtonProps {
  onDarkBackground?: boolean;
}

const InstallerRegisterButton = ({
  onDarkBackground = false,
}: InstallerRegisterButtonProps) => {
  return (
    <a
      href={`${getInstallerPanelUrl()}login`}
      target="_blank"
      rel="noopener noreferrer"
      className={`flex items-center justify-center shrink-0 whitespace-nowrap cursor-pointer rounded-lg border bg-transparent px-2 md:px-3 text-[0.6875rem] md:text-xs font-semibold transition-colors duration-300 ${
        onDarkBackground
          ? "border-white !text-white hover:bg-white/15"
          : "border-regal-blue !text-regal-blue hover:bg-regal-blue-light"
      }`}
    >
      ثبت نام پیمانکاران
    </a>
  );
};

export default InstallerRegisterButton;
